import { render, staticRenderFns } from "./WinningCompany.vue?vue&type=template&id=7a5c7055&"
import script from "./WinningCompany.vue?vue&type=script&lang=js&"
export * from "./WinningCompany.vue?vue&type=script&lang=js&"
import style0 from "./WinningCompany.vue?vue&type=style&index=0&id=7a5c7055&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports